import React, { useEffect, useState, useRef } from 'react';
import {
  NotificationsNoneOutlined,
  DarkModeOutlined,
  ChatBubbleOutlineOutlined
} from '@mui/icons-material';
import Avatar from '@mui/material/Avatar';
import axios from 'axios';
import { Link } from "react-router-dom";
import './modernNavbar.scss';

const ModernNavbar = ({ pageTitle = "Dashboard" }) => {
  const [messages, setMessages] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [heldCount, setHeldCount] = useState(0);
  const [heldList, setHeldList] = useState([]);
  const [isNotifOpen, setIsNotifOpen] = useState(false);
  const notifRef = useRef(null);

  useEffect(() => {
    axios.get('https://api.moroccool.com/api/contact')
      .then(res => {
        const sorted = res.data.sort((a, b) =>
          new Date(b.createdAt || b.date || b.timestamp) -
          new Date(a.createdAt || a.date || a.timestamp)
        );
        setMessages(sorted);
      })
      .catch(err => console.error(err));
  }, []);


  useEffect(() => {
    let stop = false;
    const check = () => {
      axios.get('https://api.moroccool.com/api/reviews/admin/list', {
        params: { status: 'held', page: 1, limit: 5 },
        withCredentials: true,
      })
        .then(res => {
          if (stop) return;
          setHeldCount(res.data.total || 0);
          setHeldList(res.data.reviews || []);
        })
        .catch(() => { });
    };
    check();
    const t = setInterval(check, 60000);
    return () => { stop = true; clearInterval(t); };
  }, []);


  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target))
        setIsDropdownOpen(false);
      if (notifRef.current && !notifRef.current.contains(e.target))
        setIsNotifOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const unread = messages.length;

  return (
    <header className="navbar">

      {/* Left — page title + breadcrumb dot */}
      <div className="navbar__left">
        <span className="navbar__eyebrow">Moroccool Admin</span>
        <h1 className="navbar__title">{pageTitle}</h1>
      </div>

      {/* Right — actions */}
      <div className="navbar__actions">

        {/* Dark mode */}
        <button className="navbar__btn" aria-label="Toggle dark mode">
          <DarkModeOutlined />
        </button>

        {/* Messages */}
        <div className="navbar__msg-wrap" ref={dropdownRef}>
          <button
            className="navbar__btn"
            aria-label="Messages"
            onClick={() => setIsDropdownOpen(v => !v)}
          >
            <ChatBubbleOutlineOutlined />
            {unread > 0 && (
              <span className="navbar__badge">{unread > 99 ? '99+' : unread}</span>
            )}
          </button>

          {isDropdownOpen && (
            <div className="dropdown" role="dialog" aria-label="Messages">
              <div className="dropdown__header">
                <span className="dropdown__title">Messages</span>
                {unread > 0 && (
                  <span className="dropdown__count">{unread} new</span>
                )}
              </div>

              <div className="dropdown__list">
                {messages.slice(0, 6).map((msg, i) => (
                  <Link to="/contact" key={msg.id || i} className="dropdown__link">
                    <div className="dropdown__item">
                      <div className="dropdown__avatar">
                        {(msg.firstName || '?')[0].toUpperCase()}
                      </div>
                      <div className="dropdown__body">
                        <span className="dropdown__name">{msg.firstName} {msg.lastName}</span>
                        <span className="dropdown__type">{msg.clientType || 'General inquiry'}</span>
                      </div>
                      <span className="dropdown__unread-dot" aria-hidden="true" />
                    </div>
                  </Link>
                ))}
              </div>

              <Link to="/contact" className="dropdown__footer">
                View all messages
              </Link>
            </div>
          )}
        </div>

        {/* Notifications */}
        <div className="navbar__msg-wrap" ref={notifRef}>
          <button
            className="navbar__btn"
            aria-label="Notifications"
            onClick={() => setIsNotifOpen(v => !v)}
          >
            <NotificationsNoneOutlined />
            {heldCount > 0 && (
              <span className="navbar__badge">{heldCount > 99 ? '99+' : heldCount}</span>
            )}
          </button>

          {isNotifOpen && (
            <div className="dropdown" role="dialog" aria-label="New reviews">
              <div className="dropdown__header">
                <span className="dropdown__title">New reviews</span>
                {heldCount > 0 && (
                  <span className="dropdown__count">{heldCount} waiting</span>
                )}
              </div>

              <div className="dropdown__list">
                {heldList.length === 0 && (
                  <div className="dropdown__item">
                    <span className="dropdown__type">No new reviews</span>
                  </div>
                )}
                {heldList.map((rv) => (
                  <Link to="/reviews" key={rv._id} className="dropdown__link"
                    onClick={() => setIsNotifOpen(false)}>
                    <div className="dropdown__item">
                      <div className="dropdown__avatar">
                        {((rv.authorSnapshot && rv.authorSnapshot.username) || '?')[0].toUpperCase()}
                      </div>
                      <div className="dropdown__body">
                        <span className="dropdown__name">
                          {(rv.authorSnapshot && rv.authorSnapshot.username) || '?'} - {'\u2605'.repeat(rv.rating || 0)}
                        </span>
                        <span className="dropdown__type">
                          {(rv.title || rv.text || '').slice(0, 40)}
                        </span>
                      </div>
                      <span className="dropdown__unread-dot" aria-hidden="true" />
                    </div>
                  </Link>
                ))}
              </div>

              <Link to="/reviews" className="dropdown__footer"
                onClick={() => setIsNotifOpen(false)}>
                View all reviews
              </Link>
            </div>
          )}
        </div>

        {/* Divider */}
        <div className="navbar__sep" aria-hidden="true" />

        {/* Avatar */}
        <button className="navbar__avatar-btn" aria-label="Profile">
          <Avatar
            alt="Admin"
            src="https://images.unsplash.com/photo-1667835949430-a2516cc93d27?auto=format&fit=crop&w=500&q=60"
            sx={{ width: 34, height: 34 }}
          />
          <div className="navbar__online" aria-hidden="true" />
        </button>

      </div>
    </header>
  );
};

export default ModernNavbar;